//@ts-ignore
import Month from 'calendar-month';

Month.setFirstWeekDay(1);

export function getDayStart(day = new Date()) {
    const copy = new Date(day.getTime());

    copy.setHours(0, 0, 0, 0);

    return copy;
}

export const getTodayMonth = () => new Date().getMonth();
export const getTodayYear = () => new Date().getFullYear();

export const MONTH_NAMES = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
];
